module.exports = __webpack_public_path__ + "static/img/hamster.1b83083f.webp";